/**
 * tdesign v0.46.2
 * (c) 2022 tdesign
 * @license MIT
 */

var props = {
  autoWidth: Boolean,
  disabled: Boolean,
  inputValue: {
    type: Array,
    "default": void 0
  },
  defaultInputValue: {
    type: Array
  },
  panel: {
    type: Function
  },
  popupProps: {
    type: Object
  },
  popupVisible: Boolean,
  rangeInputProps: {
    type: Object
  },
  readonly: Boolean,
  status: {
    type: String,
    validator: function validator(val) {
      if (!val) return true;
      return ["success", "warning", "error"].includes(val);
    }
  },
  tips: {
    type: [String, Function]
  },
  onInputChange: Function,
  onPopupVisibleChange: Function
};

export { props as default };
//# sourceMappingURL=range-input-popup-props.js.map
